import { render, staticRenderFns } from "./demandConfirm.vue?vue&type=template&id=6e72ec9f&scoped=true"
import script from "./demandConfirm.vue?vue&type=script&lang=js"
export * from "./demandConfirm.vue?vue&type=script&lang=js"
import style0 from "./demandConfirm.vue?vue&type=style&index=0&id=6e72ec9f&prod&scoped=true&lang=css"
import style1 from "./demandConfirm.vue?vue&type=style&index=1&id=6e72ec9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e72ec9f",
  null
  
)

export default component.exports